module.exports = __webpack_public_path__ + "static/img/forum.8de249d6.svg";